<script lang="ts">
	import { Input } from "flowbite-svelte";
	import type { DataTypeInputProps } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";

	let { value = $bindable(), defaultValue, disabled, invalid, required, type = "number", inputmode, oninput, onchange, onblur, oninvalid }: DataTypeInputProps = $props();
</script>

<Input
	step="any"
	bind:value={() => (typeof value === "number" && value !== undefined ? String(value) : ""), v => (value = v === "" || v === undefined ? undefined : Number(v))}
	placeholder={defaultValue ? String(defaultValue) : undefined}
	{type}
	{inputmode}
	{disabled}
	{required}
	clearable
	color={invalid ? "red" : undefined}
	on:input={e => oninput?.(e)}
	on:change={e => onchange?.(e)}
	on:blur={e => onblur?.(e)}
	on:invalid={e => oninvalid?.(e)}
/>
